import { Component, OnInit } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormControl,
  UntypedFormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { ApilistService } from 'src/app/services/apilist.service';
import { CommonService } from 'src/app/services/common.service';
import { GlobalService } from 'src/app/services/global.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-add-state',
  standalone: true,
  imports: [
    CommonModule, // ✅ for *ngIf, *ngFor, ngStyle
    FormsModule, // ✅ for [(ngModel)]
    ReactiveFormsModule, // ✅ for reactive forms
  ],
  templateUrl: './add-state.component.html',
  styleUrls: ['./add-state.component.scss'],
})
export class AddStateComponent implements OnInit {
  display: any = 'none';
  displayDelete: any = 'none';

  stateForm: UntypedFormGroup;

  showAdd = false;
  showEdit = false;
  id: any;

  degreeType: any;
  showErr = false;
  deleteErr: any;
  state: any;

  error_messages = {
    stateName: [{ type: 'required', message: 'Please enter state name' }],
  };
  stateVal: any;
  adminName: any;
  adminImage: any;
  allState: any;
  allData: any;

  showData = false;
  showNodata = false;

  searchval: any;
  stateData: any;
  constructor(
    public utils: ApilistService,
    public commonservice: CommonService,
    public globalService: GlobalService,
    public formBuilder: UntypedFormBuilder,
    private spinner: NgxSpinnerService
  ) {
    this.stateForm = this.formBuilder.group({
      stateName: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
    });

    let admin = JSON.parse(localStorage.getItem('adminDetails'));
    let adminData = JSON.parse(admin);

    this.adminName = adminData[0].name;
    this.adminImage = adminData[0].image;
    if (this.adminImage == null || this.adminImage == undefined) {
      this.adminImage = 'assets/tenant-avatar.jpg';
    }
  }

  ngOnInit(): void {
    const servicePathstate = this.utils.getApiConfigs('state');
    this.commonservice
      .invokeService(servicePathstate[1].method, servicePathstate[1].path, '')
      .then((resp: any) => {
        // console.log("state", resp);
        if (resp.status_code == '200') {
          this.stateData = resp.data;
          // console.log("state", this.stateData);

          if (this.stateData == '') {
            this.showNodata = true;
            this.showData = false;
          } else {
            this.showData = true;
            this.showNodata = false;
          }
        }
        this.stateVal = this.stateData;
      });
  }

  onChangeEvent(event) {
    // console.log("event", event);

    var val = event.target.value;
    // console.log("val", val);

    this.allData = this.stateData;

    // console.log("All Data", this.allData);

    if (val) {
      this.stateVal = this.allData.filter((item) =>
        item.state.toLowerCase().includes(val.toLowerCase())
      );
    }

    // console.log("Courses Data", this.allCountry);
    if (this.stateVal == '') {
      this.globalService.showError('No data found');
    }
  }

  reset() {
    this.ngOnInit();
    this.searchval = '';
  }

  onCloseHandled() {
    this.display = 'none';
    this.displayDelete = 'none';
    this.ngOnInit();
  }

  openAdd() {
    this.stateForm.reset();
    this.display = 'block';
    this.showAdd = true;
    this.showEdit = false;
  }

  addState() {
    this.spinner.show();
    let payload = {
      state: this.state,
    };
    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('state');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          // console.log(resp);
          this.spinner.hide();
          this.globalService.showSuccess('State added successfully');
          this.display = 'none';
          this.ngOnInit();
          this.stateForm.reset();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          // console.log("data", resp.data);
          this.globalService.showError(resp.data);
        }
      });
  }

  deleteState(data) {
    // console.log("data");
    this.displayDelete = 'block';
    this.deleteErr = '';
    this.id = data.id;
  }

  delete() {
    this.spinner.show();
    let payload = {
      id: this.id,
    };
    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('deletestate');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          // console.log(resp);
          this.globalService.showSuccess('State deleted successfully');
          this.displayDelete = 'none';
          this.ngOnInit();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          // console.log("data", resp.message);
          this.deleteErr = resp.message;
          this.showErr = true;
        }
      });
  }
}
